/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProcessInspectionDialog extends Common.GridEditorDialog<ProcessInspectionRow> {
        protected getFormKey() { return ProcessInspectionForm.formKey; }
        protected getLocalTextPrefix() { return ProcessInspectionRow.localTextPrefix; }

        protected form = new ProcessInspectionForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.Min);
            q.setTextRightAlign(this.form.Max);
            this.form.IsNumeric.changeSelect2(e => {
                if (this.form.IsNumeric.value) {
                    q.showAndSetRequiredField(this.form.Min);
                    q.showAndSetRequiredField(this.form.Max);
                } else {
                    q.hideField(this.form.Min);
                    q.hideField(this.form.Max);
                }
            })

        }
        onDialogOpen() {
            super.onDialogOpen();
            if (this.form.IsNumeric.value) {
                q.showAndSetRequiredField(this.form.Min);
                q.showAndSetRequiredField(this.form.Max);
            } else {
                q.hideField(this.form.Min);
                q.hideField(this.form.Max);
            }
        }
        validateBeforeSave() {
            super.validateBeforeSave();
            if (this.form.IsNumeric.value) {
                var _value = parseFloat(this.form.Value.value);
                if (isNaN(_value) || _value == NaN) {
                    q.alert('', 'Value invalid for Range Inspection', true, 2000);
                    return false;
                }

                if (this.form.Min.value > _value || this.form.Max.value < _value) {
                    q.alert('', 'Expected Value should be in the Range', true, 2000);
                    return false;
                }

            }
            return true;
        }
    }
}